'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagSearcher = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _collapse = require('antd/lib/collapse');

var _collapse2 = _interopRequireDefault(_collapse);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _tooltip = require('antd/lib/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _alert = require('antd/lib/alert');

var _alert2 = _interopRequireDefault(_alert);

var _dragItem = require('../dnd/dragItem');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagSearcher = exports.TagSearcher = (_temp = _class = function (_Component) {
  _inherits(TagSearcher, _Component);

  function TagSearcher(props) {
    _classCallCheck(this, TagSearcher);

    var _this = _possibleConstructorReturn(this, (TagSearcher.__proto__ || Object.getPrototypeOf(TagSearcher)).call(this, props));

    _this.state = {
      keyword: '',
      entityCode: '',
      tagCode: '',
      objectList: [],
      tagsMap: {},
      dimsMap: {}
    };
    _this.handleChange(props.entityCode, props.tagCode, props.objectList);
    return _this;
  }

  _createClass(TagSearcher, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // #! objectList发生变化时因为请求单个entity的tagList #! 只有可能改变entityCode和tagCode, 用来定位
      var mergeProps = {
        entityCode: this.state.entityCode,
        tagCode: this.state.tagCode,
        objectList: this.state.objectList,
        keyword: this.state.keyword
      };
      var keyword = this.state.keyword;
      var hasReceive = true;

      switch (true) {
        case this.props.entityCode !== nextProps.entityCode:
          mergeProps.entityCode = nextProps.entityCode;
          break;
        case this.props.tagCode !== nextProps.tagCode:
          mergeProps.tagCode = nextProps.tagCode;
          break;
        case nextProps.objectList !== this.props.objectList:
          mergeProps.objectList = nextProps.objectList;
          break;
        case this.props.keyword !== nextProps.keyword:
          keyword = '';
          // #! 因为setState是异步的
          this.setState({ keyword: '' });
          mergeProps.keyword = nextProps.keyword;
          break;
        default:
          hasReceive = false;
          break;
      }
      if (hasReceive) {
        // #! 搜索时，请求tagList会导致objectList更新
        if (keyword) {
          var _state$keyword$split = this.state.keyword.split('.'),
              _state$keyword$split2 = _slicedToArray(_state$keyword$split, 1),
              entityCodeOrName = _state$keyword$split2[0];

          var objectList = nextProps.objectList.filter(function (item) {
            return item.entityCode.indexOf(entityCodeOrName) > -1 || item.entityName.indexOf(entityCodeOrName) > -1;
          });
          this.handleChange(mergeProps.entityCode, mergeProps.tagCode, objectList);
        } else if (mergeProps.keyword) {
          this.handleSearch(mergeProps.keyword);
        } else {
          this.handleChange(mergeProps.entityCode, mergeProps.tagCode, mergeProps.objectList);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props !== nextProps || this.state !== nextState;
    }
  }, {
    key: 'getDims',
    value: function getDims(object) {
      // #! entity
      if (object.dims) {
        return object.dims.map(function (dim) {
          return { name: dim.dimCode, code: dim.dimId, entityCode: object.entityCode };
        });
        // #! link
      } else if (object.objects) {
        return object.objects.map(function (obj) {
          return {
            name: obj.entityCode + '.' + obj.dims[0].dimCode,
            code: obj.relationshipId,
            entityCode: object.entityCode
          };
        });
      }
    }

    // #! 展开object或者定位object和tag

  }, {
    key: 'handleChange',
    value: function handleChange(entityCode, tagCode, objectList) {
      var tagsMap = {};
      var dimsMap = {};
      var object = entityCode ? objectList.find(function (item) {
        return item.entityCode === entityCode;
      }) : objectList[0];
      var focusItem = void 0;
      if (object) {
        // #! 需要定位的元素, 定位到entity
        if (entityCode) {
          focusItem = object;
        }
        if (object.tagList) {
          tagsMap[entityCode] = {
            list: object.tagList
          };
          if (tagCode) {
            // #! 如果有tagCode则是定位到tag
            focusItem = object.tagList.find(function (tag) {
              return tag.tagCode === tagCode;
            });
            tagsMap[entityCode].tagCode = focusItem ? focusItem.tagCode : '';
          }
        } else if (entityCode) {
          tagsMap[entityCode] = {
            loading: true,
            list: []
          };
          // #! 请求
          this.props.doFetchTagList(entityCode);
        }
        dimsMap[entityCode] = this.getDims(object);
      }
      if (focusItem) {// undefined表示collaspse的点击
        // 延迟200毫秒后定位
      }
      this.setState({
        tagCode: tagCode,
        entityCode: entityCode,
        objectList: objectList,
        tagsMap: tagsMap,
        dimsMap: dimsMap
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(keyword) {
      var _this2 = this;

      var _keyword$split = keyword.split('.'),
          _keyword$split2 = _slicedToArray(_keyword$split, 2),
          entityCodeOrName = _keyword$split2[0],
          tagCodeOrName = _keyword$split2[1];

      var tagsMap = {};
      var dimsMap = {};
      var objectList = this.props.objectList;
      if (entityCodeOrName) {
        objectList = objectList.filter(function (item) {
          // #! 匹配name或者code
          if (item.entityCode.indexOf(entityCodeOrName) > -1 || item.entityName.indexOf(entityCodeOrName) > -1) {
            if (tagCodeOrName) {
              if (item.tagList) {
                // #! 匹配name或者code
                tagsMap[item.entityCode] = {
                  list: item.tagList.filter(function (tag) {
                    return tag.tagCode.indexOf(tagCodeOrName) > -1 || tag.tagName.indexOf(tagCodeOrName) > -1;
                  })
                };
              } else {
                tagsMap[item.entityCode] = {
                  loading: true,
                  list: []
                };
                _this2.props.doFetchTagList(item.entityCode);
              }
            } else {
              if (item.tagList) {
                tagsMap[item.entityCode] = {
                  list: item.tagList
                };
              } else {
                tagsMap[item.entityCode] = {
                  loading: true,
                  list: []
                };
                _this2.props.doFetchTagList(item.entityCode);
              }
              dimsMap[item.entityCode] = _this2.getDims(item);
            }
            return true;
          } else {
            return false;
          }
        });
      }

      var entityCode = objectList[0] && objectList[0].entityCode;
      var tagCode = tagsMap[entityCode] && tagsMap[entityCode].list.length && tagsMap[entityCode].list[0].tagCode;
      this.setState({ entityCode: entityCode, tagCode: tagCode, objectList: objectList, tagsMap: tagsMap, dimsMap: dimsMap });
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      this.setState({ keyword: '' });
      this.handleSearch('');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          keyword = _state.keyword,
          entityCode = _state.entityCode,
          objectList = _state.objectList,
          tagsMap = _state.tagsMap,
          dimsMap = _state.dimsMap;
      // #! 判断是否需要拖拽

      var doDrag = this.props.doDrag;
      var ItemDom = _dragItem.DragItem;
      if (!doDrag) {
        /* eslint-disable no-unused-vars */
        ItemDom = function ItemDom(_ref) {
          var children = _ref.children;

          return _react2.default.createElement(
            'div',
            null,
            _this3.props.children
          );
        };
      }

      // #! 遍历输出所有object,
      // 展开的object必然有dims，不展开则没有；展开的object必然有tagList（分为空和有列表数据，！！完全找不到则需要发请求去拿），不展开则没有
      // 。 #! handleChange，展开object；handleSearch，搜索object或tag
      return _react2.default.createElement(
        'div',
        { className: 'j-com-tagSearcher' },
        _react2.default.createElement(_input2.default.Search, {
          placeholder: this.props.searchPlaceholder || '使用 实体.标签 进行模糊搜索',
          value: keyword,
          suffix: keyword ? _react2.default.createElement(_icon2.default, { type: 'close-circle', onClick: function onClick() {
              return _this3.clearSearch();
            } }) : null,
          onChange: function onChange(e) {
            _this3.setState({ keyword: e.target.value });
          },
          onSearch: function onSearch() {
            return _this3.handleSearch(_this3.state.keyword);
          } }),
        _react2.default.createElement(
          'div',
          { className: 'j-com-elem-oltList' },
          this.props.keyword ? _react2.default.createElement(_alert2.default, { message: '\u901A\u8FC7\u5224\u5B9A\u5F0F\u5B9A\u4F4D', type: 'info', closable: true, onClose: function onClose() {
              return _this3.clearSearch();
            } }) : null,
          _react2.default.createElement(
            _collapse2.default,
            {
              accordion: true,
              activeKey: entityCode,
              onChange: function onChange(key) {
                return _this3.handleChange(key, '', objectList);
              } },
            objectList.map(function (entity) {
              return _react2.default.createElement(
                _collapse2.default.Panel,
                {
                  key: entity.entityCode,
                  header: _react2.default.createElement(
                    ItemDom,
                    { key: entity.entityCode, doAction: doDrag, type: 'entity', data: entity },
                    _react2.default.createElement('div', { className: 'j-com-elem-icon-entity' }),
                    _react2.default.createElement(
                      'span',
                      { title: entity.entityCode + '(' + entity.entityName + ')' },
                      entity.entityCode + '(' + entity.entityName + ')'
                    )
                  ) },
                _react2.default.createElement(
                  'ul',
                  null,
                  dimsMap[entity.entityCode] && dimsMap[entity.entityCode].map(function (dim, index) {
                    return _react2.default.createElement(
                      'li',
                      { key: index },
                      _react2.default.createElement(
                        ItemDom,
                        { key: dim.code, doAction: doDrag, type: 'dim', data: dim },
                        _react2.default.createElement('div', { className: 'j-com-elem-icon-dim' }),
                        _react2.default.createElement(
                          _tooltip2.default,
                          {
                            placement: 'right',
                            title: (entity.entityType === 'object' && '实体' || '关系') + '(' + entity.entityName + ')\u4E0B\u53EF\u7528\u7684\u6807\u7B7E' },
                          _react2.default.createElement(_icon2.default, { type: 'pushpin-o', className: 'j-com-elem-icon-pushpin-o' })
                        ),
                        _react2.default.createElement(
                          'span',
                          { title: dim.name },
                          dim.name
                        )
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  tagsMap[entity.entityCode] && (tagsMap[entity.entityCode].loading ? _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u6B63\u5728\u62C9\u53D6...'
                    )
                  ) : tagsMap[entity.entityCode].list.length ? tagsMap[entity.entityCode].list.map(function (tag, index) {
                    return _react2.default.createElement(
                      'li',
                      { key: index },
                      _react2.default.createElement(
                        ItemDom,
                        { key: tag.tagCode, doAction: doDrag, type: 'tag', data: tag },
                        _react2.default.createElement('div', { className: 'j-com-elem-icon-tag' }),
                        _react2.default.createElement(
                          _tooltip2.default,
                          {
                            placement: 'right',
                            title: (entity.entityType === 'object' && '实体' || '关系') + '(' + entity.entityName + ')\u4E0B\u53EF\u7528\u7684\u6807\u7B7E' },
                          _react2.default.createElement(_icon2.default, { type: 'tag-o', className: 'j-com-elem-icon-tag-o' })
                        ),
                        _react2.default.createElement(
                          'span',
                          { title: tag.tagCode + '(' + tag.tagName + ')' },
                          tag.tagCode + '(' + tag.tagName + ')'
                        )
                      )
                    );
                  }) : _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u65E0\u6807\u7B7E'
                    )
                  ))
                )
              );
            })
          )
        )
      );
    }
  }]);

  return TagSearcher;
}(_react.Component), _class.propTypes = {
  entityCode: _propTypes2.default.string.isRequired,
  tagCode: _propTypes2.default.string.isRequired,
  keyword: _propTypes2.default.string.isRequired,
  objectList: _propTypes2.default.array.isRequired,
  doFetchTagList: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.any,
  doDrag: _propTypes2.default.func,
  searchPlaceholder: _propTypes2.default.string
}, _class.defaultProps = {
  entityCode: '',
  tagCode: '',
  keyword: '',
  objectList: []
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/tagSearcher/index.jsx
// module id = 102
// module chunks = 0